export default "__VITE_ASSET__76b5ecb8__"